// Redirects any `import ... from 'vue'` (used internally by npm packages such as
// @vuepic/vue-datepicker) to the single global Vue instance loaded via vendor/vue.global.prod.js
// (enqueued separately in theme-setup/scripts.php). This keeps exactly one Vue runtime on the
// page — a component library bundled against its own separate copy of Vue would get incompatible
// internal symbols (Fragment, Teleport, etc.) from the app's own Vue instance.
module.exports = window.Vue
